import type { UserInfo } from "@/services/users/types/user.types";
import { needsCompleteRegistration } from "@/utils/registrationProfile";

/**
 * Do not call `/external/courses` until we know the user finished "Complete seu cadastro".
 * Also wait for `phoneNumberValidated === true`: while `/me` is loading, that flag can be
 * missing/false and `needsCompleteRegistration` incorrectly returned false — which fired PDC
 * before the modal could finish (404 Member not found).
 * After profile is complete, `syncPdcMember` aligns the member in PDC; we do not gate on
 * `pdcMemberSynced` alone or the query would never enable when `/me` lags.
 */
export function canFetchPdcExternalCourseList(user: UserInfo | undefined): boolean {
  if (!user?.id) return false;
  if (user.phoneNumberValidated !== true) return false;
  if (needsCompleteRegistration(user)) return false;
  return true;
}

/**
 * When true, the /courses list is loaded from sg-pdc-api GET /external/courses
 * (x-api-key from localStorage `_csgb`) instead of sgb-reality-api.
 * Disabled while mock courses are on to avoid conflicting dev setups.
 */
export function isPdcExternalCourseListEnabled(): boolean {
  return (
    import.meta.env.VITE_USE_PDC_EXTERNAL_COURSE_LIST === "true" &&
    import.meta.env.VITE_USE_MOCK_COURSES !== "true"
  );
}

/** Base URL of sg-pdc-api (no trailing slash), e.g. https://pdc-api.example.com */
export function getPdcApiBaseUrl(): string {
  const primary = (import.meta.env.VITE_PDC_API_URL as string | undefined)?.trim();
  const alias = (import.meta.env.VITE_SG_PDC_API_URL as string | undefined)?.trim();
  const raw = primary || alias || "";
  return raw.replace(/\/$/, "");
}
